import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import {
  makeStyles,
  Card,
  Grid,
  TextField,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  Button,
  CircularProgress,
} from '@material-ui/core';
import { httpClient } from 'appUtility/Api';
import React, { useEffect, useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { history } from 'redux/store';

const qs = require('qs');

const useStyles = makeStyles(theme => ({
  root: {
    padding: '40px',
  },
  form: {
    width: '100%',
  },
  text: {
    width: '100%',
  },
  uploadImage: {
    cursor: 'pointer',
    textAlign: 'center',
    padding: '40px 0',
    border: `1px solid #999`,
    borderRadius: '5px',
    '&:hover': {
      border: `1px solid #333`,
    },
    '& .MuiSvgIcon-root': {
      fontSize: '45px',
    },
  },
  imgClass: {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
  },
  snack:{
    "& .MuiAlert-action":{
      alignItems: "flex-start",
      paddingTop:"7px"
    }
  }
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ChangeProfile = props => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState([]);
  const [messageState, setMessageState] = useState('');

  var loginData = JSON.parse(sessionStorage.getItem('login'));

  // const [profileID, setProfileID] = useState(props && props.location.pathname.slice(26));
  const [loading, setLoading] = useState(false);
  const [profileDetails, setProfileDetails] = useState({
    firstName: loginData !== null ? loginData.user.firstName : '',
    lastName: loginData !== null ? loginData.user.lastName : '',
    changePassword: false,
    currentPassword: '',
    password: '',
    confirmedPassword: '',
  });


  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);

    httpClient
      .post(
        '/user/change-profile',
        qs.stringify({
          firstName: profileDetails.firstName,
          lastName: profileDetails.lastName,
          changePassword: profileDetails.changePassword === true ? 1 : 0,
          currentPassword: profileDetails.currentPassword,
          password: profileDetails.password,
          confirmedPassword: profileDetails.confirmedPassword,
        }),
      )
      .then(({ data }) => {
        if (data.success === true) {
          setOpen(true);
          setMessageState('success');
          setMessage(data.message);
          setLoading(false);
          setProfileDetails({
            firstName: loginData !== null ? loginData.user.firstName : '',
            lastName: loginData !== null ? loginData.user.lastName : '',
            changePassword: false,
            currentPassword: '',
            password: '',
            confirmedPassword: '',
          });
          var login = JSON.parse(sessionStorage.getItem('login'));
          login.user = data.data;

          sessionStorage.setItem("login", JSON.stringify(login));

          window.location.reload();
        } else {
          setOpen(true);
          setMessageState('error');
          setMessage(data.message);
          setLoading(false);
        }
      });
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setProfileDetails({
      ...profileDetails,
      [name]: value,
    });
  };

  const handleCheck = e => {
    const { name, checked } = e.target;
    setProfileDetails({
      ...profileDetails,
      [name]: checked,
    });
  };

  const handleBack = () => {
    history.push("/dashboard")
  };

  return (
    <PageContainer heading={'Profile'}>
      <Card className={classes.root}>
        <form className={classes.form} onSubmit={handleSubmit}>
          <Grid container spacing={4}>
            <Grid item sm={12} md={12}>
              <TextField
                required
                label="First Name"
                variant="outlined"
                name="firstName"
                type="text"
                value={profileDetails.firstName}
                className={classes.text}
                onChange={handleChange}
              />
            </Grid>

            <Grid item sm={12} md={12}>
              <TextField
                required
                label="Last Name"
                variant="outlined"
                name="lastName"
                type="text"
                value={profileDetails.lastName}
                className={classes.text}
                onChange={handleChange}
              />
            </Grid>

            <Grid item sm={12} md={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="changePassword"
                    checked={profileDetails.changePassword}
                    onChange={handleCheck}
                    value={profileDetails.changePassword}
                    color="primary"
                  />
                }
                label="Change Password?"
              />
            </Grid>

            {profileDetails.changePassword === true && (
              <Grid item sm={12} md={12}>
                <TextField
                  label="Current Password"
                  variant="outlined"
                  name="currentPassword"
                  type="password"
                  value={profileDetails.currentPassword}
                  className={classes.text}
                  onChange={handleChange}
                />
              </Grid>
            )}

            {profileDetails.changePassword === true && (
              <Grid item sm={12} md={12}>
                <TextField
                  label="Password"
                  variant="outlined"
                  name="password"
                  type="password"
                  value={profileDetails.password}
                  className={classes.text}
                  onChange={handleChange}
                />
              </Grid>
            )}

            {profileDetails.changePassword === true && (
              <Grid item sm={12} md={12}>
                <TextField
                  label="Confirm Password"
                  variant="outlined"
                  name="confirmedPassword"
                  type="password"
                  helperText={profileDetails.password !== profileDetails.confirmedPassword && 'Password does not match!'}
                  value={profileDetails.confirmedPassword}
                  className={classes.text}
                  onChange={handleChange}
                />
              </Grid>
            )}
            <Grid item sm={12} md={12} style={{ textAlign: 'right' }}>
              <Button color="secondary" variant="contained" style={{ marginRight: '10px' }} onClick={handleBack}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="primary" disabled={profileDetails.password !== profileDetails.confirmedPassword ? true : false}>
                {'Submit'}
              </Button>
              {loading && <CircularProgress size={20} style={{ marginLeft: '10px' }} />}
            </Grid>
          </Grid>
        </form>
      </Card>

      <Snackbar
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={open}
        onClose={handleClose}>
        <Alert onClose={handleClose} severity={messageState}>
        {messageState === "success" ?
            message
          : (message.length > 0 && message.map(msg => <p>{msg}</p>))
          }
        </Alert>
      </Snackbar>
    </PageContainer>
  );
};

export default ChangeProfile;
